// ResetPassword.jsx
import React from "react";
import {ReactComponent as AuthLogoIcon} from "../../icons/auth-logo.svg";
import PrimaryButton from "../ui/buttons/PrimaryButton";
import TextButton from "../ui/buttons/TextButton";
import AuthOverlay from "./AuthOverlay";

export default function ResetPassword({onClose, onSwitch}) {
  // DEV
  const dev = true;

  return (
    <AuthOverlay onClose={onClose} className="center">
      <div
        className="
          relative bg-white rounded-[20px] flex flex-col items-center
          w-[90%] max-w-[360px] p-6
          sm:max-w-[400px]
          md:max-w-[440px] md:p-8
          lg:w-[486px] lg:p-10
        "
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Logo block */}
        <div
          className="
            absolute flex items-center justify-center overflow-hidden rounded-[16px]
            w-12 h-12 -top-6
            sm:w-14 sm:h-14
            lg:w-16 lg:h-16 lg:-top-[10%]
          "
          aria-hidden="true"
        >
          <AuthLogoIcon/>
        </div>
        {/* Dev notice */}
        <div className="mt-6 w-[358px]">
          <div className="w-full rounded-[12px] border border-[#FFE2B3] bg-[#FFF7E6] px-4 py-3">
            <div className="text-[12px] font-bold uppercase tracking-[0.08em] text-[#9A5B00]">
              В разработке
            </div>
            <div className="mt-1 text-[13px] leading-[18px] text-[#5C607C]">
              Самостоятельное восстановление пароля недоступно. Востановление пароля выполняется через администрацию.
            </div>
          </div>
        </div>
        {/* Dev notice */}
        {/* Header */}
        <div
          className="
            mt-8 flex flex-col gap-3 items-stretch w-full
            lg:w-[358px] lg:mt-6
          "
        >
          <h1
            className="
              m-0 font-bold text-center tracking-[-0.02em] text-[#01051F]
              text-[22px] leading-[30px]
              sm:text-[24px] sm:leading-[32px]
              lg:text-[28px] lg:leading-[38px]
            "
          >
            Восстановление пароля
          </h1>
          <p
            className="
              m-0 font-normal text-center text-[#5C607C]
              text-[14px] leading-[22px]
              sm:text-[15px] sm:leading-[24px]
              lg:text-[16px] lg:leading-[28px]
            "
          >
            Укажите почту, на неё отправим ссылку для смены пароля
          </p>
        </div>

        {/* Form */}
        <form
          className="
            mt-8 flex flex-col gap-2 w-full
            lg:w-[358px]
          "
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="flex flex-col gap-1 mb-2 lg:h-[102px]">
            <label
              className="
                inline-block font-medium text-[#040E44]
                text-[14px] leading-6
                sm:text-[15px]
                lg:text-[16px]
              "
            >
              Почта
            </label>

            <div
              className="
                box-border flex items-center bg-white border border-[#C4CBF5]
                shadow-[0_1px_10px_rgba(4,14,68,0.12)] rounded-[10px]
                w-full h-[44px] py-[10px] px-[14px]
                lg:h-[46px]
              "
            >
              <input
                disabled={dev}
                className="
                  w-full h-6 border-0 outline-none bg-transparent text-[#5C607C]
                  text-[15px] leading-6
                  sm:text-[16px]
                "
                type="email"
                placeholder="Укажите почту"
              />
            </div>

            <p
              className="
                text-[#D30B0B]
                text-[11px] leading-[18px]
                sm:text-[12px]
              "
            >
              Ошибка
            </p>
          </div>

          <PrimaryButton disabled={dev}
                         type="submit" className="w-full max-w-[358px]">
            Отправить ссылку
          </PrimaryButton>
        </form>

        {/* Footer label */}
        <p
          className="
            mt-6 text-center font-medium text-[#333F51]
            text-[11px] leading-[18px]
            sm:text-[12px]
            lg:w-[358px] lg:h-[18px]
          "
        >
          Вспомнили пароль?{" "}
          <TextButton onClick={onSwitch}>Войти</TextButton>
        </p>
      </div>
    </AuthOverlay>
  );
}